import { Component } from '@angular/core';
import { Events } from 'ionic-angular';

import { Api } from '../../providers/api/api';
import { IPTV } from '../../providers/iptv/iptv';
import { Utils } from '../../providers/utils/utils';

/*
*
*  Remote Page
*
*/
@Component({
  selector: 'remote',
  templateUrl: 'remote.html'
})
export class Remote {
    
    public live: any = {};
    public setting: any = {};
    public empty: boolean;
    public range = 50;
    public isLoading : boolean = false;
    
    constructor(  
        public events: Events, 
        public utils: Utils,
        public IPTV: IPTV,
        private api : Api
    ) {

        this.events.subscribe('app:refresh', (params : any = {}) => { 
            this.init(true);
        });

        this.init();
    }

    init(noLoad:boolean=false) {

        if (!noLoad) this.isLoading = true;

        this.fetchSettings().then((data:any = {}) => {

            if (data && (
                   parseInt(data.arrow_button)
                || parseInt(data.backward)
                || parseInt(data.blue)
                || parseInt(data.cross_button)
                || parseInt(data.cut_vol_button)
                || parseInt(data.down_arrow)
                || parseInt(data.down_vol_button)
                || parseInt(data.eight)
                || parseInt(data.fast_backward)
                || parseInt(data.fast_forward)
                || parseInt(data.five)
                || parseInt(data.forward)
                || parseInt(data.four)
                || parseInt(data.green)
                || parseInt(data.home_buton)
                || parseInt(data.information_button)
                || parseInt(data.left_arrow)
                || parseInt(data.min_button)
                || parseInt(data.more_button)
                || parseInt(data.nine)
                || parseInt(data.ok_button)
                || parseInt(data.one)
                || parseInt(data.pause)
                || parseInt(data.play)
                || parseInt(data.record)
                || parseInt(data.red)
                || parseInt(data.right_arrow)
                || parseInt(data.seven)
                || parseInt(data.six)
                || parseInt(data.stop)
                || parseInt(data.three)
                || parseInt(data.two)
                || parseInt(data.up_arrow)
                || parseInt(data.up_vol_button)
                || parseInt(data.yellow)
                || parseInt(data.zero))
            ) {
                this.setting = data;
                this.empty = false;
            } else {
                if (this.IPTV.box.manufacturer != 'CHROMECAST') this.empty = true;
            }

            this.IPTV.remote_HOOK = data.number_value;

            if (!noLoad) this.isLoading = false;
        }, (err) => {
            if (!noLoad) this.isLoading = false;
            this.utils.error(this.api.reject(err));
        });
    }

    /*
    *    Fetch from api
    */
    fetchSettings() {
        return new Promise((resolve, reject) => {
            this.api.getCached('iptv/setting/'+this.IPTV.boxID, {}, null, 3000).subscribe((response:any)=>{
                resolve(response.result.result);
            },(err) => {
                reject(this.api.reject(err));
            });
        });
    }

}



// WEBPACK FOOTER //
// ./src/pages/remote/remote.ts